module.exports = __webpack_public_path__ + "static/assets/37ceab93476b337a4a004fded2fe5aeb.svg";